module.exports = __webpack_public_path__ + "static/Amazon Prime-8d2313d7ba2af3bc1826fa62192fc05f.png";